import React from "react";
import { Link } from "react-router-dom";

const AdminSidebar = () => {
  return (
    <div className="admin-sidebar">

      <h2>Admin Panel</h2>

      <Link to="/admin/dashboard">Dashboard</Link>
      <Link to="/admin/birthday">Birthday</Link>
      <Link to="/admin/slider">Slider</Link>
      <Link to="/admin/academics">Academics</Link>
      <Link to="/admin/galleryAwards">Gallery & Awards</Link>
      <Link to="/admin/notice">Notice</Link>
      <Link to="/admin/student-work">Student Work</Link>
      <Link to="/admin/event">Event</Link>
      <Link to="/admin/news">News</Link>
      <Link to="/admin/gallery-album">Gallery</Link>
      <Link to="/admin/uploadDocuments">Upload Homeworks</Link>
      <Link to="/admin/cbse">CBSE Document</Link> 
      <Link to="/admin/adminstudent-tc">Student TC</Link>
      <Link to="/admin/admin-tour">Virtual Tour</Link>
      <Link to="/admin/admin-online">Online Registration Data</Link>
      <Link to="/admin/admin-holiday">Holiday</Link>
      <Link to="/admin/admin-class">Class Monitor</Link>
      <Link to="/admin/admin-studentcouncil">Student Council</Link>
      <Link to="/admin/admin-house">School House</Link>
      <Link to="/admin/alumni">Alumni</Link>
      <Link to="/admin/password">Change Password</Link>
        
    </div>
  );
};

export default AdminSidebar;